// KaTeX wrapper for inline + display equations. Per 01_renderer.md:
// display equations carry `data-block-id` so the viewport observer in
// `useActiveGlossaryTerms` picks them up; inline math sits inside paragraphs
// whose block IDs already cover the observer.

import { useMemo } from "react";
import katex from "katex";
import "katex/dist/katex.min.css";

interface MathProps {
  display: boolean;
  raw: string;
  blockId?: string;
}

export function Math({ display, raw, blockId }: MathProps) {
  const html = useMemo(
    () =>
      katex.renderToString(raw, {
        displayMode: display,
        throwOnError: false,
        trust: (ctx) => ctx.command === "\\htmlClass" || ctx.command === "\\htmlId",
        strict: "ignore",
      }),
    [raw, display],
  );
  if (display) {
    return (
      <div
        className="maisight-math-display"
        data-block-id={blockId}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    );
  }
  return (
    <span
      className="maisight-math-inline"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
